<template>
  <div>
    <el-container style="overflow: hidden">
      <div style="float: left; width: 70%">
        <el-form inline>
          <el-form-item label="出库计划">
            <el-input
              v-model="filters.ShippingNo"
              id="inputId"
              placeholder="请输入出库计划"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="SKU">
            <el-input
              id="inputName"
              v-model="filters.SKUCode"
              placeholder="请输入SKU"
              clearable
            ></el-input>
          </el-form-item>

          <el-form-item label="库位">
            <el-input
              id="inputName"
              v-model="filters.LocationCode"
              placeholder="请输入库位"
              clearable
             
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div style="float: left; width: 30%">
        <toolbar
          :buttonList="buttonList"
          @callFunction="callFunction"
        ></toolbar>

        <!-- <el-button type="primary" @click="addBoxMark">提交</el-button> -->
      </div>
    </el-container>
    <el-container>
      <el-main>
        <div>          
          <div class="left-item">
            <el-card class="box-card" style="width: 100%">
              <div slot="header" class="clearfix">
                <span>待拣货完成</span>
              </div>
              <div class="left-item-card">
                <div style="width:99%;">
                  <el-card
                    class="box-card"
                    v-for="(item, index) in WaitPickList"
                    :key="index"
                    style="margin-bottom: 10px; cursor: pointer; width: 100%"
                    @click.native="selectCurrentDiv(item, index)"
                    :style="{
                      'background-color': WaitPickList[index].checked
                        ? '#C5C7CC'
                        : '',
                    }"
                  >
                    <div class="text item">
                      <div>出库计划：{{ item.shippingNo }}</div>
                      <div>备货任务：{{ item.stockingNo }}</div>
                      <div>SKU：{{ item.skuCode }}</div>
                      <div>发货数量:{{ item.quantity }}</div>
                      <div>已下架数量:{{ item.outQty }}</div>
                      <div>创建时间:{{ item.createTimeDesc }}</div>
                    </div>
                  </el-card>
                </div>
              </div>
            </el-card>
          </div>
          <div
            style="float: left; margin-left: 2%; width: 78%"
            class="otherTable"
          >
            <el-table-bar :fixed="true" :bottom="35">
              <el-table
                border
                :data="tableData"
                style="width: 100%"
                v-loading="listLoading"
              >
                <el-table-column prop="skuCode" label="SKU" min-width="80">
                </el-table-column>

                <el-table-column
                  prop="locationCode"
                  label="库位"
                  min-width="50"
                >
                </el-table-column>

                <el-table-column
                  prop="skuInventoryBatchStorageList"
                  label="采购单"
                  min-width="110"
                >
                  <template slot-scope="scope">
                    <div
                      v-if="
                        scope.row.skuInventoryBatchStorageList != null &&
                        scope.row.skuInventoryBatchStorageList != ''
                      "
                    >
                      <div
                        v-for="(item, index) in scope.row
                          .skuInventoryBatchStorageList"
                        :key="index"
                      >
                        {{ item.sourceNumber }}(数量:{{ item.qty }})
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="totalQty"
                  label="库位库存"
                  min-width="50"
                >
                </el-table-column>
                 <el-table-column
                  prop="checkQty"
                  label="总库存"
                  min-width="50"
                >
                </el-table-column>
                <el-table-column prop="sku" label="入库时间" min-width="110">
                  <template slot-scope="scope">
                    <div
                      v-if="
                        scope.row.skuInventoryBatchStorageList != null &&
                        scope.row.skuInventoryBatchStorageList != ''
                      "
                    >
                      <div
                        v-for="(item, index) in scope.row
                          .skuInventoryBatchStorageList"
                        :key="index"
                      >
                        {{ item.createTimeDesc }}(数量:{{ item.qty }})
                      </div>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                  prop="outQty"
                  label="已下架数量"
                  min-width="50"
                >
                </el-table-column>
                <el-table-column
                  prop="newOutQty"
                  label="下架数量"
                  min-width="100"
                >
                  <template slot-scope="scope">
                    <el-input-number
                      v-model="scope.row.newOutQty"
                      :step="1"
                      size="small"
                    ></el-input-number>
                  </template>
                </el-table-column>
              </el-table>
            </el-table-bar>
            <div class="block">
              <el-pagination layout="total" :total="total" style="float: right">
              </el-pagination>
            </div>
          </div>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import {
  GetWaitPickList,
  GetWaitPickStockList,
  ConfirmOffShelf,
} from "@/api/outbound/waitPick.js";
import { getButtonList } from "../../promissionRouter";

import Toolbar from "../../components/Toolbar";
export default {
  components: { Toolbar },
  data() {
    return {
      filters: {},
      buttonList: [],
      listLoading: false,
      tableData: [],
      Deliverydata: [],
      total: 0,
      validation: true,
      WaitPickList: [],
    };
  },
  methods: {
    callFunction(item) {
      // this.filters = {
      //     keyword: item.search
      // };
      this[item.func].apply(this, item);
    },

    initTable() {
      GetWaitPickList(this.filters).then((res) => {
       
        var result = res.data.response;
        if (result.length > 0) {
          this.WaitPickList = res.data.response;
          this.WaitPickList[0].checked = true;
          this.QuerySkustock(this.WaitPickList[0]);
        }else{
           this.WaitPickList=[];
           this.tableData=[];
        }
      });
    },

    QuerySkustock(item) {
      this.tableData = [];
      var para = {
        shippingplanid: item.shippingPlanID,
        shippingplandetailid: item.shippingPlanDetailID,
        stockingtaskid: item.stockingTaskID,
        StockingPickDetailID: item.stockingPickDetailID,
        ProductID: item.productID,
      };
   const loading = this.$loading({
        lock: true,
        text: "请稍等...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      GetWaitPickStockList(para).then((res) => {
          loading.close();
        this.tableData = res.data.response;
        this.total = this.tableData.length;
      });
    },

    selectCurrentDiv(obj, i) {
      this.WaitPickList.forEach((item, index) => {
        this.$set(this.WaitPickList[index], "checked", false);
      });
      this.QuerySkustock(this.WaitPickList[i]);
      this.$set(this.WaitPickList[i], "checked", true);
    },

    offshelves() {
      if (this.tableData == null || this.tableData.length <= 0) {
        this.$message({
          message: "下架数据为空!",
          type: "error",
        });
        return;
      }
      var flag = false;

      this.tableData.forEach((item, index) => {
        if (item.newOutQty > item.totalQty) {
          this.$message({
            message: "库位:" + item.locationCode + ":下架数量不能大于库位库存!",
            type: "error",
          });
          flag = true;
          return;
        }
      });
      if (flag) {
        return false;
      }

      this.$confirm("确认下架吗?", "提示", {})
        .then(() => {
           const loading = this.$loading({
        lock: true,
        text: "请稍等...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
          ConfirmOffShelf(this.tableData).then((res) => {
              loading.close();
            if (res.data.success) {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.tableData = [];
              this.initTable();
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },

  mounted() {
    document.getElementById("inputId").focus();
    let user = JSON.parse(window.localStorage.user);
    console.info(user);
    this.typeVisible = user.isSa;

    console.log(this.$route);
    this.filters={ShippingNo:this.$route.query.ShippingNo,SKUCode:this.$route.query.SKUCode};
  
    if (
      this.$route.query.ShippingNo != null ||
      this.$route.query.ShippingNo != ""
    ) {
      this.initTable();
    }

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>



<style scoped lang="less">
.left-item {
  float: left;
  width: 20%;
}
.left-item-card{
  max-height: 500px;
  overflow: hidden;
  overflow-y: scroll;
}

.left-item-card {
  &::-webkit-scrollbar {
    height: 6px;
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background-color: #fff;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgb(207, 210, 217);
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background-color: rgb(184, 182, 182);
  }
}
</style>